<template>
  <div>
    <div class="sure-charge">
      <div class="detail">
        <el-row style="margin-top: 10px;">
          <el-col :span="5" class="col-left">缴费年度</el-col>
          <el-col :span="16" class="col-right" style="color: green">{{yearTitle}}</el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="5" class="col-left">供暖卡号</el-col>
          <el-col :span="16" class="col-right">{{cardNum}}</el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="5" class="col-left">用户姓名</el-col>
          <el-col :span="16" class="col-right">{{userName}}</el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="5" class="col-left">供热站</el-col>
          <el-col :span="16" class="col-right">{{heating}}</el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="5" class="col-left">小区名称</el-col>
          <el-col :span="16" class="col-right">{{houseName}}</el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="5" class="col-left">楼牌地址</el-col>
          <el-col :span="16" class="col-right">{{address}}</el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="5" class="col-left">商网名称</el-col>
          <el-col :span="16" class="col-right">{{netName}}</el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="5" class="col-left">联系电话</el-col>
          <el-col :span="16" class="col-right">{{tel}}</el-col>
        </el-row>
      </div>
      <div class="detail">
        <p class="col-left">供暖面积（平方米）</p>
        <el-row style="margin-top: 10px">
          <el-col :span="5" class="area">住宅面积</el-col>
          <el-col :span="5" class="col-right"><p class="floatRight">{{houseArea}}</p></el-col>
          <el-col :span="5" class="area" style="margin-left: 20px">商铺面积</el-col>
          <el-col :span="5" class="col-right"><p class="floatRight">{{netArea}}</p></el-col>
        </el-row>
        <el-row style="margin-top: 10px">
          <el-col :span="5" class="area">企业面积</el-col>
          <el-col :span="5" class="col-right"><p class="floatRight">{{companyArea}}</p></el-col>
          <el-col :span="5" class="area" style="margin-left: 20px">其他面积</el-col>
          <el-col :span="5" class="col-right"><p class="floatRight">{{otherArea}}</p></el-col>
        </el-row>
      </div>
      <div class="chargePrice">
        <el-row style="margin-top: 10px;">
          <el-col :span="5" class="col-left">应收金额</el-col>
          <el-col :span="5" class="col-right"><p class="floatRight" style="color: #0033CC;">{{totalPrice}}</p></el-col>
          <p style="margin-top: 4px">元</p>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="4" class="priceTitle">减免金额</el-col>
          <el-col :span="5" class="col-right priceLeft"><p class="floatRight" style="color: #0033CC;">{{taxPrice}}</p>
          </el-col>
          <p style="margin-top: 4px">元</p>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="4" class="priceTitle">滞纳金</el-col>
          <el-col :span="5" class="col-right priceLeft"><p class="floatRight" style="color: #0033CC;">
            {{revenuePrice}}</p></el-col>
          <p style="margin-top: 4px">元</p>
        </el-row>
        <el-row>
          <el-col :span="5" class="col-left">实缴金额</el-col>
          <el-col :span="5" class="col-right"><p class="floatRight" style="color: red;">{{chargePrice}}</p></el-col>
          <p style="margin-top: 4px">元</p>
        </el-row>
        <el-row style="margin-top: 10px; height: 27px">
          <el-col :span="6" class="col-left">
            <nut-checkbox
              v-model="otherCheck"
              :animation="false"
              size="small">
            </nut-checkbox>
            <span class="other" style="color: green">代缴费</span>
          </el-col>
          <el-col :span="12">
            <input v-show="otherCheck" maxlength="11" class="zw_input" v-model="otherPhone" type="text"
                   placeholder="请输入卡号用户的手机号" @blur="fixScroll">
          </el-col>
        </el-row>
        <el-row style="margin-top: 10px;">
          <el-col :span="5" class="col-left">缴费日期</el-col>
          <el-col :span="10" style="font-size: 15px; margin-top: 5px">{{chargeTime}}</el-col>
        </el-row>
      </div>
    </div>
    <div class="but">
      <el-button style="width: 70%;" type="success" size="small" :disabled="disConfirm" @click="confirm">确认缴费
      </el-button>
    </div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'

  const wx = window.jWeixin || require('weixin-js-sdk')
  export default {
    name: "sureCharge",
    data() {
      return {
        // userID: 2,
        userID: this.$store.getters.getUserInfo.userID,
        // openID: "o5vFewIMieT8e-ScGJBzmXVfmxNA",
        openID: this.$store.getters.getUserInfo.openID,
        yearTitle: this.$route.query.yearTitle,
        cardNum: this.$route.query.cardNum,
        client_payment_id: 0,
        clientID: 0,
        userName: "",
        heating: "",
        houseName: "",
        address: "",
        netName: "",
        tel: "",
        houseArea: 0,
        netArea: 0,
        companyArea: 0,
        otherArea: 0,
        totalPrice: 0.0,//应收金额
        chargePrice: 0,
        taxPrice: 0.0,
        revenuePrice: 0.0,
        chargeTime: "",
        disConfirm: true,
        otherCheck: false,
        otherPhone: "",
      }
    },
    methods: {
      getCharge() {
        let params = {
          yearData: this.yearTitle,
          clientCode: this.cardNum
        };
        this.$http.getPayment(params).then(res => {
          if (res.state === 1) {
            let chargeDetail = res.data.row[0];
            this.client_payment_id = chargeDetail.clientPaymentId;
            this.cardNum = chargeDetail.clientCode;
            this.clientID = chargeDetail.clientID;
            this.userName = chargeDetail.clientMstName;
            this.heating = chargeDetail.heatStationName;
            this.houseName = chargeDetail.housingEstateName;
            this.address = chargeDetail.housingAdd;
            this.netName = chargeDetail.clientMstSellerName;
            this.tel = chargeDetail.clientMstMobile;
            this.houseArea = chargeDetail.residentArea;
            this.netArea = chargeDetail.houseMstSellerArea;
            this.companyArea = chargeDetail.houseMstOther1Area;
            this.otherArea = chargeDetail.houseMstOther2Area;
            this.totalPrice = chargeDetail.totleAmountPrice;
            this.chargePrice = chargeDetail.totleAmountPrice;
            this.taxPrice = chargeDetail.favorablePrice;
            this.revenuePrice = chargeDetail.remissionPrice;
            this.chargeTime = chargeDetail.updataDate;
            if (this.userName !== null) {
              this.editName();
            }
            if (this.tel !== null) {
              this.editTel();
            }
          } else {
            Toast({
              message: '服务器繁忙请稍后再试',
              duration: 2000
            })
          }

        })
      },

      // 提交预支付
      confirm() {
        let phone = /^1[34578]\d{9}$/;
        if (this.otherPhone !== "") {
          if (!phone.test(this.otherPhone)) {
            Toast({
              message: "请输入正确的手机号！",
              duration: 2000
            });
            return;
          }
        }
        this.disConfirm = true;
        let params = {
          userID: this.userID,
          openID: this.openID,
          client_payment_id: this.client_payment_id,
          clientID: this.clientID,
          totalFee: this.chargePrice,
          phone: this.otherPhone
        };
        this.$http.generatePayment(params).then((response) => {
          if (response.state === 1) {
            if (this.chargePrice === 0 || this.chargePrice === 0.00) {
              let paramsTradeNo = {
                tradeNo: response.data.tradeNo
              }
              this.$http.checkTotalFee(paramsTradeNo).then((response) => {
                this.$router.replace({
                  path: "/charge-success",
                  query: {
                    bankBusinessNo: response.data.bankBusinessNo,
                    totalFee: response.data.totalFee,
                    billAddress: response.data.address,
                    billTel: response.data.tel
                  }
                })
              })
            } else {
              this.prepay(response.data.tradeNo)
            }
          } else {
            Toast({
              message: response.msg,
              duration: 2000
            })
          }
        })
      },

      prepay(tradeNo) {
        let params = {
          userID: this.userID,
          openID: this.openID,
          totalFee: this.chargePrice * 100,
          tradeNo: tradeNo
        }
        this.$http.prepay(params).then((response) => {
          if (response.state === 1) {
            this.pay(response.data.prepay_id, tradeNo)
          } else {
            Toast({
              message: response.msg,
              duration: 2000
            })
          }
        })
      },
      // 支付
      pay(prepayId, tradeNo) {
        let that = this
        let params = {
          prepay_id: prepayId,
          tradeNo: tradeNo
        }
        this.$http.pay(params).then((response) => {
          if (response.state === 1) {
            wx.chooseWXPay({
              timestamp: response.data.timestamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
              nonceStr: response.data.nonceStr, // 支付签名随机串，不长于 32 位
              package: response.data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
              signType: response.data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
              paySign: response.data.paySign, // 支付签名
              success: function (res) { // 支付成功后的回调函数
                // let instance = Toast({
                //   message: '支付成功',
                //   iconClass: 'mint-toast-icon mintui mintui-success'
                // })
                // setTimeout(() => {
                //   instance.close()
                that.$router.replace({
                  path: "/charge-success",
                  query: {
                    bankBusinessNo: response.data.bankBusinessNo,
                    totalFee: response.data.totalFee,
                    billAddress: response.data.address,
                    billTel: response.data.tel
                  }
                })
                // }, 2000)
              },
              cancel: function () {
                that.disConfirm = false
              }
            })
          } else {
            Toast({
              message: response.msg,
              duration: 2000
            })
          }
        })
      },

      editName() {
        this.userName = '**' + this.userName.substr(-1)
      },

      editTel() {
        this.tel = this.tel.replace(/(\d{3})\d{5}(\d{3})/, "$1*****$2");
      },

      wxConfig() {
        let that = this;
        let params = {
          url: encodeURIComponent(location.href.split('#')[0])
        }
        this.$http.getJSSDKConfig(params).then((response) => {
          wx.config({
            debug: false,
            appId: response.appId,
            timestamp: response.timestamp,
            nonceStr: response.nonceStr,
            signature: response.signature,
            jsApiList: ['chooseWXPay'],
          });
          wx.ready(() => {
            that.disConfirm = false;
          });
          wx.error((res => {
            Toast({
              message: "系统繁忙，请稍后再试",
              duration: 2000
            })
            setTimeout(function () {
              that.$route.go(-1);
            },2000)
          }))
        })
      },
      // 解决苹果不回弹页面
      fixScroll() {
        let u = navigator.userAgent;
        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        // var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
        // alert('是否是Android：' + isAndroid);
        // alert('是否是iOS：' + isIOS);
        if (isIOS) {
          window.scrollTo(0, 0);
        }
      }
    },
    created() {
      this.wxConfig()
    },
    mounted() {
      this.getCharge();
    }
  }
</script>

<style scoped>
  /*标题字体 15px*/
  /*内容字体13px*/
  .sure-charge {
    position: absolute;
    width: 100%;
    height: 90%;
    top: 0;
    left: 0;
    overflow-y: auto;
  }

  .yearTag {
    text-align: center;
    height: 50px;
    border-bottom: 1px solid #F2F6FC;
    margin-top: 10px;
  }

  .detail {
    margin-top: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #F2F6FC;
  }

  .col-left {
    margin-top: 5px;
    font-size: 15px;
    font-weight: 800;
    margin-left: 20px;
  }

  .col-right {
    /*background-color: #DCDEE3;*/
    border-radius: 4px;
    padding: 5px;
    font-size: 13px;
  }

  .floatRight {
    float: right;
  }

  .area {
    font-size: 13px;
    margin-top: 5px;
    margin-left: 20px;
  }

  .priceTitle {
    margin-top: 5px;
    font-size: 13px;
    margin-left: 30px;
  }

  .priceLeft {
    margin-left: 5px;
  }

  .chargePrice {
    margin-bottom: 10px;
  }

  .but {
    position: fixed;
    bottom: 0px;
    width: 100%;
    height: 32px;
    padding-top: 10px;
    padding-bottom: 10px;
    text-align: center;
    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.2);
    background-color: #fff;

  }

  .other {
    font-size: 15px;
    margin-top: 5px;
    margin-left: 5px;
  }

  .zw_input {
    width: 165px;
    height: 100%;
    padding: 5px;
    border: 1px solid #DCDFE6; /*#DCDFE6*/
    border-radius: 4px;
    -webkit-appearance: none;
  }




</style>




// WEBPACK FOOTER //
// src/pages/sureCharge.vue